<template>
  <div class="choose-card">
    <!-- <div class="card-group">
      <div class="item" v-for="(item, groupIndex) in pageData" :key="item.groupName">
        <p class="group-title bold">{{item.groupName}}</p>
        <div class="fx fx-wrap">
          <div class="card-item" v-for="(card, index) in item.cardFaceList" :key="card.cardFaceUrlImage" @click="onCardTap(index, groupIndex, card.cardFaceUrlImage, card.cardFaceRemarks)">
            <van-image :src="card.cardFaceUrlImage"></van-image>
            <van-icon name="checked" size="18" v-show="card.check" />
          </div>
        </div>
      </div>
    </div> -->
    <div class="card-group">
      <!-- <div class="item" v-for="(item, groupIndex) in items" :key="item.groupName"> -->
        <div class="fx fx-wrap">
          <div class="card-item" v-for="(item, index) in items" :key="item.cardFaceUrlImage" @click="onCardTap(index, item.cardFaceUrlImage, item.cardFaceRemarks)">
            <div v-if="item.cardFaceUrlImage" class="img-box">
              <img :src="item.cardFaceUrlImage" />
              <van-icon name="checked" size="18" v-show="item.check" />
              <p>{{item.title}}</p>
            </div>
          </div>
        </div>
      <!-- </div> -->
    </div>
    <div class="btn">
      <van-button :disabled="isDisabled" type="info" size="large" round @click="goPage">OK</van-button>
    </div>
  </div>
</template>

<script>
export default {
  data () {
    return {
      pageData: {},
      current: '',
      isDisabled: true,
      changeRemark: '',
      desc: '',
      items: []
    }
  },
  created () {
    this.loadData()
    this.$util.storageSet('session', 'hideToast', true)
    this.changeRemark = this.$route.query.changeRemark
  },
  methods: {
    // 所有卡面
    getCardFaceListByApp (params) {
      return this.$http.post('/olvp/getCardFaceListByApp', 'getCardFaceListByApp', params, false, false)
    },
    loadData () {
      this.getCardFaceListByApp({
        marketId: this.$util.storageGet('local', 'marketId')
      }).then((d) => {
        const data = d.content.dataList
        data.map((v) => {
          v.cardFaceList.map((r) => {
            r.title = v.groupName
            this.items.push(r)
          })
        })
      })
    },
    onCardTap (i, img, remarks) {
      this.items.map((v) => {
        v.check = false
      })
      this.items[i].check = true
      this.$set(this.items, i, this.items[i])
      this.current = img
      this.isDisabled = false
      this.desc = remarks
    },
    goPage () {
      this.$nextTick(() => {
        this.$router.back()
        this.$util.storageSet('session', 'giftImg', this.current)
        if (this.changeRemark === 'false') {
          this.$util.storageSet('session', 'giftDesc', this.desc)
        }
      })
    }
  }
}
</script>

<style lang="scss">
  .choose-card {
    width: 100%;
    height: 100%;

    .card-group {
      padding: 15px 15px 120px 15px;
      .item {
        .group-title {
          font-size: 15px;
          color: #666;
          margin: 20px 0;
        }
      }
    }
    .card-item {
          width: 48%;
          background: #fff;
          position: relative;
          .van-image {
            border-radius: 5px;
            box-shadow: 0 2px 8px #ccc;
            overflow: hidden;
          }
          p {
            line-height: 30px;
          }
          img {
            height: 109px;
          }
          .van-icon {
            position: absolute;
            right: 5px;
            top: 5px;
            color: #1989fa;
          }
        }
        .card-item:nth-child(odd) {
          margin-right: 4%;
        }
    .btn {
      background: #fff;
      width: 100%;
      padding: 20px;
      position: fixed;
      left: 0;
      right: 0;
      bottom: 0;
    }
    .img-box {
      box-shadow: 0 2px 8px #ccc;
      border-radius: 5px;
      margin-bottom: 15px;
      overflow: hidden;
      p {
        padding: 0 8px;
        white-space: nowrap;
        text-overflow: ellipsis;
        overflow: hidden;
      }
    }
  }
</style>
